export interface IShopifyConfig {
  cartEndpoint: string
  graphqlApiEndpoint: string
  yfSubscriptionPrivateEndpoint: string
  storefrontAccessToken: string
  adminApiAccessToken: string
  adminApiEndpoint: string
}

const shopifyURL = process.env.SHOPIFY_STORE_URL || "https://business.factor75.com"

export const shopify: IShopifyConfig = {
  cartEndpoint: `${shopifyURL}/cart`,
  graphqlApiEndpoint: `${shopifyURL}/api/2022-04/graphql`,
  yfSubscriptionPrivateEndpoint: process.env.YF_SUBSCRIPTION_PRIVATE_API,
  storefrontAccessToken: process.env.SHOPIFY_STOREFRONT_ACCESS_TOKEN,
  adminApiAccessToken: "",
  adminApiEndpoint: `${shopifyURL}/admin/api/2024-04`
}
